const env = require('/opt/build/repo/twing/environment.js');
let templatesModule = (() => {
let module = {
    exports: undefined
};

module.exports = (TwingTemplate) => {
    return new Map([
        [0, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = false;

                this.blocks = new Map([
                ]);
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(this.include(context, this.source, this.loadTemplate(`b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, 1, 58), undefined, true, false, 1));
            }

            getTemplateName() {
                return `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`;
            }

            getSourceContext() {
                return new this.Source(``, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, ``);
            }
        }],
        [58, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, 1);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`    <p>
      This paragraph is in a rhythm object with
      `);
                if ((context.has(`amount`) ? context.get(`amount`) : null)) {
                    this.echo(`        <code>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(6, this.source)(...[this.env, (context.has(`amount`) ? context.get(`amount`) : null), `html`, null, true]));
                    this.echo(`</code>
      `);
                }
                else {
                    this.echo(`        no
      `);
                }
                this.echo(`      spacing set.
    </p>
    <p>
      This list is also a rhythm object
      `);
                if (!!((context.has(`nested_amount`) ? context.get(`nested_amount`) : null) && !this.compare((context.has(`nested_amount`) ? context.get(`nested_amount`) : null), (context.has(`amount`) ? context.get(`amount`) : null)))) {
                    this.echo(`        but with <code>`);
                    this.echo(this.env.getFilter('escape').traceableCallable(15, this.source)(...[this.env, (context.has(`nested_amount`) ? context.get(`nested_amount`) : null), `html`, null, true]));
                    this.echo(`</code>`);
                }
                else {
                    this.echo(`with inherited`);
                }
                this.echo(`      spacing:
    </p>
    `);
                this.echo(this.include(context, this.source, this.loadTemplate(`b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, 21, 57), new Map([[`tag_name`, `ul`], [`amount`, (context.has(`nested_amount`) ? context.get(`nested_amount`) : null)]]), false, false, 21));
                this.echo(`  `);
            }

            getTemplateName() {
                return `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, ``);
            }
        }],
        [57, class extends TwingTemplate {
            constructor(env) {
                super(env);

                this.source = this.getSourceContext();
                this.macros = new this.Context();
                let macros = new this.Context();

                this.parent = this.loadTemplate(`@cloudfour/objects/rhythm/rhythm.twig`, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, 21);

                this.blocks = new Map([
                    ['content', [this, 'block_content']]
                ]);
            }

            doGetParent(context) {
                return `@cloudfour/objects/rhythm/rhythm.twig`;
            }

            doDisplay(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.parent.display(context, this.merge(this.blocks, blocks));
            }

            block_content(context, blocks = new Map()) {
                let macros = this.macros.clone();
                this.echo(`        <li><a href="#">Accessibility</a></li>
        <li><a href="#">Design Systems</a></li>
        <li><a href="#">Performance</a></li>
        <li><a href="#">Progressive Web Apps</a></li>
      `);
            }

            getTemplateName() {
                return `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`;
            }

            isTraitable() {
                return false;
            }

            getSourceContext() {
                return new this.Source(``, `b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d`, ``);
            }
        }],
    ]);
};

    return module.exports;
})();

env.registerTemplatesModule(templatesModule, 'b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d');

let template = env.loadTemplate('b7fce5ece9fb75fefd3c7748b067a2afa303f776823b91b2b36171a601de6b5d');

module.exports = (context = {}) => {
    const rendered = template.render(context);
     const inputs = window.__twig_inputs__ || (window.__twig_inputs__ = new Map());
     inputs.set(
       rendered,
       { path: "@cloudfour/objects/rhythm/demo/nesting.twig", args: context }
     );
     return rendered;;
};